module.exports = global["jQuery"] = require("-!E:\\dev\\repos\\wpo_sitecontrol\\node_modules\\jquery\\dist\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?jQuery!./~/jquery/dist/jquery.js
// module id = 168
// module chunks = 1